export default __webpack_public_path__ + "images/very_happy.6a2b75f27cce7a6291e05192a4550ae1.svg";